export default __webpack_public_path__ + "static/media/contact_us.96371a3b.svg";